exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-3c7c3f50], .modal-backdrop[data-v-3c7c3f50] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n.modal.open[data-v-3c7c3f50], .modal-backdrop.open[data-v-3c7c3f50] {\n  display: block;\n}\n.modal.fadein[data-v-3c7c3f50], .modal-backdrop.fadein[data-v-3c7c3f50] {\n  opacity: 1;\n}\n.modal .modal-body[data-v-3c7c3f50], .modal-backdrop .modal-body[data-v-3c7c3f50] {\n  max-height: calc(100vh - 11.75rem);\n  overflow: auto;\n}\n.modal-backdrop[data-v-3c7c3f50] {\n  display: none;\n}\n.modal-backdrop.fadein[data-v-3c7c3f50] {\n  opacity: 0.5;\n}", ""]);

// exports
